import { Document } from './types';

export const transformDocument = (res: any): Document => {
  return { filePath: res, deleted: false };
};

export const transformToRequestDocument = (document: Document): string => {
  return document.filePath;
};
